import React, { useEffect } from "react";
import { Radio } from "@mantine/core";
import { useForm, Controller } from "react-hook-form";

const SelectClaimType = ({ setStepone, onSubmit, claimReason }) => {
  const {
    control,
    handleSubmit,
    formState: { errors },
    watch, // Add watch to monitor form field changes
    setValue,
  } = useForm();

  const claimType = watch("claimType"); // Watch the "claimType" field

  // 1. Initialize form from localStorage
  useEffect(() => {
    const savedClaimType = localStorage.getItem("claimType");
    if (savedClaimType) {
      setValue("claimType", savedClaimType);
      setStepone(true);
    } else if (claimReason) {
      setValue("claimType", claimReason.value);
    }
  }, [claimReason, setValue]);

  // 2. Save to localStorage when value changes
  useEffect(() => {
    if (claimType) {
      localStorage.setItem("claimType", claimType);
      setStepone(true);
    } else {
      setStepone(false);
    }
  }, [claimType, setStepone]);

  const handleFormSubmit = (data) => {
    onSubmit(data); // Pass the form data to the parent component
  };

  return (
    <div className="select-claim-type stepper-container">
      <h3 className="stepper-header">Select claim type</h3>

      <form onSubmit={handleSubmit(handleFormSubmit)} id="claim-type-form">
        <div>
          <h4 className="stepper-sub-header">
            What happened to your flightsss?
            <span style={{ color: "red" }}> *</span>
          </h4>
          <div className="radio-options-wrapper">
            <Controller
              name="claimType"
              control={control}
              rules={{ required: "This field is required" }}
              render={({ field }) => (
                <Radio.Group {...field} value={field.value}>
                  <Radio
                    color="red"
                    variant="outline"
                    value="delayed"
                    label="My flight was delayed"
                  />

                  <Radio
                    color="red"
                    variant="outline"
                    value="cancelled"
                    label="My flight was canceled"
                  />
                  <Radio
                    color="red"
                    variant="outline"
                    value="denied_boarding"
                    label="I was denied boarding due to overbooking"
                  />
                  <Radio
                    color="red"
                    variant="outline"
                    value="lost/damaged"
                    label="My baggage was lost, delayed, or damaged"
                  />
                  <Radio
                    color="red"
                    variant="outline"
                    value="other"
                    label="Other issue"
                  />
                </Radio.Group>
              )}
            />
            {errors.claimType && (
              <p style={{ color: "red" }}>{errors.claimType.message}</p>
            )}
          </div>
        </div>
      </form>
    </div>
  );
};

export default SelectClaimType;
